import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  children: string;
  htmlFor?: string;
  optional?: boolean;
}

function FormFieldLabel({ children, htmlFor, optional }: IProps) {
  const { t } = useTranslation();
  return (
    <label className="modFormFieldLabel" htmlFor={htmlFor}>
      {optional && <span className="modFormFieldLabel__optional">{t('general.optional')}</span>}
      {children}
    </label>
  );
}

export default FormFieldLabel;
